export default "__VITE_ASSET__VcPtBfF1__"